import {
  collection,
  onSnapshot,
  FirestoreError,
  query,
  Unsubscribe,
} from "firebase/firestore";
import { db } from "../../firebase";
import { EntityGet, EntityServerGet, ListServiceOpts } from "../../types";
import { Workplace } from "./types";
import { transformMetadata, processTimestampFields } from "../../utils";

export type WorkplaceOnSnapshotCollectionService<T> = (
  agentId: string,
  opts: ListServiceOpts,
  callback: (docs: Array<T>) => void,
  onError?: (error: FirestoreError) => void
) => Unsubscribe;

const onSnapshotCollection: WorkplaceOnSnapshotCollectionService<
  EntityGet<Workplace>
> = (agentId, opts: ListServiceOpts, callback, onError = () => {}) => {
  const collectionRef = collection(db, `/agent/${agentId}/workplace`);
  const { disableCache } = opts;
  const q = opts.listQueryFn
    ? opts.listQueryFn(collectionRef)
    : query(collectionRef);
  return onSnapshot(
    q,
    { includeMetadataChanges: disableCache },
    (querySnap) => {
      const { metadata } = querySnap;
      const { fromCache } = metadata;
      if (disableCache && fromCache) return;
      callback(
        querySnap.docs.map(
          (doc) =>
            processTimestampFields(
              transformMetadata(
                {
                  ...doc.data(),
                  id: doc.id,
                } as EntityServerGet<Workplace>,
                doc.metadata
              )
            ) as EntityGet<Workplace>
        )
      );
    },
    onError
  );
};

export default onSnapshotCollection;
